import { useState, useEffect } from "react";

import styled from "styled-components";

import { getUserProfileImg } from "../../api/user";

interface PostAuthorProps {
  data?: any;
  avatarUrls?: any;
  showDescription?: boolean;
}

const PostAuthor: React.FC<PostAuthorProps> = ({ data, showDescription = true }) => {
  const [avatarUrl, setAvatarUrl] = useState<string>("");

  useEffect(() => {
    if (data?.profileImgPath) {
      try {
        getUserProfileImg(data.profileImgPath).then((blobData) => {
          const thumbData = window.URL.createObjectURL(blobData && blobData);
          setAvatarUrl(thumbData);
        });
      } catch (e) {
        console.error(`Failed to load avatar for ${data.name}`, e);
      }
    } else {
      setAvatarUrl("");
    }
  }, [data]);

  return (
    <AuthorItem>
      <AuthorInner>
        <div
          style={{
            width: "100%",
            height: "104px",
          }}
        >
          {avatarUrl === "" ? (
            <>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  backgroundColor: "lightgray",
                }}
              ></div>
            </>
          ) : (
            <>
              <img
                src={avatarUrl}
                alt=""
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "100%",
                }}
              />
            </>
          )}
        </div>
        <AuthorName>{data?.name}</AuthorName>
        {showDescription && (
          <AuthorDescription>{data?.description || "Atlas"}</AuthorDescription>
        )}
      </AuthorInner>
    </AuthorItem>
  );
};

const AuthorItem = styled.li`
  display: flex;
  justify-content: flex-end;
`;

const AuthorInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 1rem;
  width: 79px;
`;

const AuthorName = styled.span`
  white-space: nowrap;
  font-weight: 600;
  font-size: 0.9rem;
  color: #262626;
`;

const AuthorDescription = styled.span`
  font-size: 0.75rem;
  color: #8c8c8c;
  margin-top: 2px;
`;

export default PostAuthor;
